import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'orderDate';
export const apiKey = 'OrderDateTime';
export const type = TYPE_DATE_COMPARISON;

export const orderDate = {
  id,
  apiKey,
  type,
};
